module.exports = __webpack_public_path__ + "img/logo.a4ff60fd.png";